const { BookingStates, BookingTypes } = require('./src/constants/booking');
const Payment = require('./src/constants/payment');
const { ErrorCodes } = require('./src/constants/errors');
const { Destinations } = require('./src/constants/destinations');
const { ActyvystAPIError } = require('./src/util/api-error');

const { PaymentProviders } = Payment; // LEGACY, moved to Services.Payment

module.exports = {
    Constants: {
        Destinations,
        BookingStates,
        BookingTypes,
        PaymentProviders,
        ErrorCodes
    },
    Services: {
        Payment
    },
    Util: {
        ActyvystAPIError
    },
    Translations: {

    }
}